/*
Tier Expansion (New) - Progress Banner
For new rewards program, CM content for landing page should contain one banner per each tier plus a generic one
Layout variant is 'isc-loyalty-tier-banner' for all of them so the key is used to pick the right banner depending
on user consent and tier. Generic banner will be returned if user has opted out, opted in but loyaltySegment is
undefined or opted in but no matching content was found on CM

Possible keys:
- myaccount_top_banner_tier_expansion_bronze
- myaccount_top_banner_tier_expansion_silver
- myaccount_top_banner_tier_expansion_gold
- myaccount_top_banner_tier_expansion_eip
- myaccount_top_banner_tier_expansion_eip-platinum
- myaccount_top_banner_tier_expansion_opt-out
*/
export default function getProgressBannerItem(content, loyaltyConsent, currentTier) {
    const tierKey = { 'eipplatinum': 'eip-platinum' }[currentTier] || currentTier
    return content?.items?.find((item) => item?.key === `myaccount_top_banner_tier_expansion_${loyaltyConsent === 'true' && currentTier ? tierKey : 'opt-out'}`)
        || content?.items?.find((item) => item?.key === 'myaccount_top_banner_tier_expansion_opt-out')
}